<template>
  <CompanyWrapper :isOpenEvent="!isLogin">
    <main class="main">
      <!-- 再読み込み画面 -->
      <section v-if="!referrerData" class="oauth-result-section">
        <p>{{ Link.reload[lang] }}</p>
        <div class="reload-link" v-if="lang === 'ja' && isLogin">
          <img
            src="../../../../assets/images/triangle-right-purple.svg"
            alt=""
          />
          <router-link
            :to="{ path: `/${langPath}company/event/${nassEventId}` }"
            class="link t-underline"
          >
            {{ Link.guide2[lang] }}
          </router-link>
        </div>
        <div class="coop-link">
          <img
            src="../../../../assets/images/triangle-right-purple.svg"
            alt=""
          />
          <span class="link">
            {{ Link.doneSentence3[lang]
            }}<a
              :href="`${Link.pdf[lang]}`"
              class="t-underline"
              target="_blank"
              rel="noopener"
              >{{ Link.here[lang] }}</a
            >
          </span>
        </div>
        <RunkeeperCapture :link="Link" :lang="lang"></RunkeeperCapture>
      </section>
      <!-- 成功 -->
      <section v-if="isRegister && referrerData" class="oauth-result-section">
        <p class="coop-sentence">
          {{ Link.done[lang] }}
        </p>
        <div class="done-block">{{ Link.doneSentence[lang] }}</div>
        <div class="text-center">
          <div class="app-name"
            >{{ Link.doneSentence2[lang] }}&nbsp;{{ runnerName }}</div
          >
        </div>
        <div class="coop-link" v-if="lang === 'ja' && isLogin">
          <img
            src="../../../../assets/images/triangle-right-purple.svg"
            alt=""
          />
          <router-link
            :to="{ path: `/${langPath}company/event/${nassEventId}` }"
            class="link t-underline"
          >
            {{ Link.return2[lang] }}
          </router-link>
        </div>
        <div class="coop-link">
          <img
            src="../../../../assets/images/triangle-right-purple.svg"
            alt=""
          />
          <span class="link">
            {{ Link.doneSentence3[lang]
            }}<a
              :href="`${Link.pdf[lang]}`"
              class="t-underline"
              target="_blank"
              rel="noopener"
              >{{ Link.here[lang] }}</a
            >
          </span>
        </div>
        <RunkeeperCapture :link="Link" :lang="lang"></RunkeeperCapture>
      </section>
      <!-- 失敗 -->
      <section v-if="!isRegister && referrerData" class="oauth-result-section">
        <p class="coop-sentence">
          {{ Link.error[lang] }}
        </p>
        <div class="coop-link" v-if="lang === 'ja' && isLogin">
          <img
            src="../../../../assets/images/triangle-right-purple.svg"
            alt=""
          />
          <router-link
            :to="{ path: `/${langPath}company/event/${nassEventId}` }"
            class="link t-underline"
          >
            {{ Link.return2[lang] }}
          </router-link>
        </div>
      </section>
    </main>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/pc/company/CompanyWrapper";
import RunkeeperCapture from "../../../../components/pc/oauth/RunkeeperCapture";
import Link from "../../../../assets/constants/link/link";
import cognito from "../../../../plugins/cognito";
export default {
  data() {
    return {
      referrerData: null,
      isRegister: null,
      runnerName: "",
      nassEventId: "",
      isLogin: false,
    };
  },
  created() {
    // イベントID取得
    this.nassEventId = sessionStorage.getItem("nassEventId");
    const userAgent = window.navigator.userAgent.toLowerCase();
    // ログイン状態取得
    this.isLogin = cognito.getUserName();
    // リロード時
    // 2020/11 performanceNavigationTiming.type はIE非対応のため使用してない
    if (window.performance.navigation.type === 1) {
      this.referrerData = 0;
      return;
    }
    // 成功判定
    this.isRegister = this.$route.query.register === "success";
    this.runnerName = this.$route.query.runner_name;
    // リファラー判定：IEはリファラーが取れないため完了・失敗文言を一律で表示する
    if (
      document.referrer.includes("https://dev.tmf-virtualrun.jp") ||
      document.referrer.includes("https://tmf-virtualrun.jp") ||
      document.referrer.includes("https://runkeeper.com") ||
      !userAgent.includes("msie") ||
      !userAgent.includes("trident")
    ) {
      this.referrerData = 1;
      return;
    }
    this.referrerData = 0;
  },
  computed: {
    Link: function () {
      return Link;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    CompanyWrapper,
    RunkeeperCapture,
  },
  name: "Link",
};
</script>

<style scoped>
.main {
  .oauth-result-section {
    margin: 40px 0 0 0;
    .reload-link,
    .coop-link {
      margin: 40px 0 0 0;
      display: flex;
      align-items: center;
      .link {
        margin: 0 0 0 10px;
        color: #000;
      }
    }
    .coop-sentence {
      text-align: center;
      font-size: 32px;
    }
    .done-block {
      margin: 52px 0 0 0;
      line-height: 1.5;
    }
    .app-name {
      display: inline-block;
      margin: 30px 0 0 0;
      padding: 24px 48px;
      font-size: 32px;
      font-weight: bold;
      background-color: #eee;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/company/link/Link.vue